module.exports = __webpack_public_path__ + "img/rule.01dfd34e.png";